// extracted by mini-css-extract-plugin
module.exports = {"container":"CollectionList_container__3YLC2","spacer":"CollectionList_spacer__2lhTo"};